import CustomMenu from './customMenu.component';

export default CustomMenu;